// state
const state = {
    msj: {
        mostrar: false,
        txt: '',
        tipo: '',
        errores: []
    }
};

// mutations
const mutations = {
    msjSetEstado(state, estado) {
        console.log(estado);
        state.msj.mostrar = estado;
    },
    msjShow(state, payload) {
        state.msj.mostrar = true;
        state.msj.txt = payload.txt;
        state.msj.tipo = payload.tipo;
        state.msj.errores = payload.errores;
    },
};

// actions
const actions = {
    msjSetEstado({commit}, payload) {
        commit('msjSetEstado', payload)
    },
    msjShow({commit}, payload) {
        commit('msjShow', payload)
    },
};

// getters
const getters = {
    msj: state => state.msj,
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/notif.js